var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "12", md: "12" } },
                [
                  _c("v-text-field", {
                    ref: "CorreoElectronico",
                    attrs: {
                      counter: "",
                      maxlength: "80",
                      "prepend-inner-icon": "mdi-email",
                      required: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "text-center" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.emailType === "EmailFE"
                                      ? "Correo Electrónico Facturas Electrónicas"
                                      : "Correo Electrónico Delivery"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  staticStyle: {
                    "background-color": "rgb(204 33 40)",
                    color: "white !important",
                  },
                  attrs: { text: "" },
                  on: { click: _vm.updateEmail },
                },
                [_vm._v(" Actualizar ")]
              ),
            ],
            1
          ),
          _c(
            "v-alert",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.successAlert,
                  expression: "successAlert",
                },
              ],
              attrs: { type: "success", text: "" },
            },
            [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }